<main>
  <section
    style="
      background-image: url('assets/images/customer-registration-hero.jpg');
      background-size: cover;
      background-position: center;
    "
  >
    <div class="container px-4 py-5">
      <div class="row align-items-start g-lg-5 py-5">
        <div class="col-lg-10 text-lg-start text-light">
          <h1 class="display-4 lh-1 mb-3 py-4">Customer Registration</h1>
        </div>
      </div>
    </div>
  </section>

  <div class="container">
    <div class="row px-4 py-4 mt-5 text-center">
      <p class="display-5 mb-4">Create your new account</p>
      <div class="col-lg-10 mx-auto">
        <p class="fs-5 mb-4">
          If you have a DFS Insurance policy, but have yet to register your
          online account, please fill in your information below.
        </p>
      </div>
    </div>
  </div>

  <div class="container px-4 mb-5">
    <div class="row g-5">
      <div class="col-12">
        <div class="card p-4 fs-6">
          <form [formGroup]="registerForm" (ngSubmit)="onRegister()">
            <div class="row gx-5 gy-4">
              <p *ngIf="errorMessage" class="text-danger">
                {{ errorMessage }}
              </p>
              <div class="col-md-6">
                <label class="form-label">
                  Insured First Name
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  formControlName="firstName"
                  class="form-control fs-6"
                  [ngClass]="{
                    'is-invalid':
                      registerForm.controls['firstName'].invalid &&
                      registerForm.controls['firstName'].touched,
                  }"
                  required
                />
                <div
                  *ngIf="
                    registerForm.controls['firstName'].invalid &&
                    registerForm.controls['firstName'].touched
                  "
                  class="invalid-feedback"
                >
                  First name is required.
                </div>
              </div>
              <div class="col-md-3">
                <label class="form-label">Middle Name</label>
                <input
                  type="text"
                  formControlName="middleName"
                  class="form-control fs-6"
                />
              </div>
              <div class="col-md-3">
                <label class="form-label">
                  Insured Last Name
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  formControlName="lastName"
                  class="form-control fs-6"
                  [ngClass]="{
                    'is-invalid':
                      registerForm.controls['lastName'].invalid &&
                      registerForm.controls['lastName'].touched,
                  }"
                  required
                />
                <div
                  *ngIf="
                    registerForm.controls['lastName'].invalid &&
                    registerForm.controls['lastName'].touched
                  "
                  class="invalid-feedback"
                >
                  Last name is required.
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">
                  Policy Number
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  formControlName="policyNumber"
                  class="form-control fs-6"
                  [ngClass]="{
                    'is-invalid':
                      registerForm.controls['policyNumber'].invalid &&
                      registerForm.controls['policyNumber'].touched,
                  }"
                  required
                />
                <div
                  *ngIf="
                    registerForm.controls['policyNumber'].invalid &&
                    registerForm.controls['policyNumber'].touched
                  "
                  class="invalid-feedback"
                >
                  Policy number is required.
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">
                  Email Address
                  <span class="text-danger">*</span>
                </label>
                <small class="text-muted d-block mb-1">
                  (This will be used as your username to login.)
                </small>
                <input
                  type="email"
                  formControlName="email"
                  class="form-control fs-6"
                  [ngClass]="{
                    'is-invalid':
                      registerForm.controls['email'].invalid &&
                      registerForm.controls['email'].touched,
                  }"
                  required
                />
                <div
                  *ngIf="
                    registerForm.controls['email'].invalid &&
                    registerForm.controls['email'].touched
                  "
                  class="invalid-feedback"
                >
                  <span
                    *ngIf="registerForm.controls['email'].errors?.['required']"
                  >
                    Email address is required.
                  </span>
                  <span
                    *ngIf="registerForm.controls['email'].errors?.['email']"
                  >
                    Please enter a valid email address.
                  </span>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">
                  Address 1
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  formControlName="address1"
                  class="form-control fs-6"
                  [ngClass]="{
                    'is-invalid':
                      registerForm.controls['address1'].invalid &&
                      registerForm.controls['address1'].touched,
                  }"
                  required
                />
                <div
                  *ngIf="
                    registerForm.controls['address1'].invalid &&
                    registerForm.controls['address1'].touched
                  "
                  class="invalid-feedback"
                >
                  Address is required.
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">Address 2</label>
                <input
                  type="text"
                  formControlName="address2"
                  class="form-control fs-6"
                />
              </div>
              <div class="col-md-6">
                <label class="form-label">
                  City
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  formControlName="city"
                  class="form-control fs-6"
                  [ngClass]="{
                    'is-invalid':
                      registerForm.controls['city'].invalid &&
                      registerForm.controls['city'].touched,
                  }"
                  required
                />
                <div
                  *ngIf="
                    registerForm.controls['city'].invalid &&
                    registerForm.controls['city'].touched
                  "
                  class="invalid-feedback"
                >
                  City is required.
                </div>
              </div>
              <div class="col-md-3">
                <label class="form-label">
                  State
                  <span class="text-danger">*</span>
                </label>
                <select
                  formControlName="state"
                  class="form-select fs-6"
                  [ngClass]="{
                    'is-invalid':
                      registerForm.controls['state'].invalid &&
                      registerForm.controls['state'].touched,
                  }"
                  required
                >
                  <option selected disabled value="">Select your state</option>
                  <option *ngFor="let s of states" [value]="s.abbreviation">
                    {{ s.name }}
                  </option>
                </select>
                <div
                  *ngIf="
                    registerForm.controls['state'].invalid &&
                    registerForm.controls['state'].touched
                  "
                  class="invalid-feedback"
                >
                  State is required.
                </div>
              </div>
              <div class="col-md-3">
                <label class="form-label">
                  Zip Code
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  formControlName="zipCode"
                  class="form-control fs-6"
                  [ngClass]="{
                    'is-invalid':
                      registerForm.controls['zipCode'].invalid &&
                      registerForm.controls['zipCode'].touched,
                  }"
                  required
                />
                <div
                  *ngIf="
                    registerForm.controls['zipCode'].invalid &&
                    registerForm.controls['zipCode'].touched
                  "
                  class="invalid-feedback"
                >
                  Zip code is required.
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">
                  Choose Password
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="password"
                  formControlName="password"
                  class="form-control fs-6"
                  [ngClass]="{
                    'is-invalid':
                      registerForm.controls['password'].invalid &&
                      registerForm.controls['password'].touched,
                  }"
                  required
                />
                <div
                  *ngIf="
                    registerForm.controls['password'].invalid &&
                    registerForm.controls['password'].touched
                  "
                  class="invalid-feedback"
                >
                  <span *ngIf="registerForm.controls['password'].errors?.['required']">
                    Password is required.
                  </span>
                  <span *ngIf="registerForm.controls['password'].errors?.['pattern']">
                    Passwords must contain between 12 and 20 characters, both
                    lower and uppercase letters, and at least one number or
                    special character.
                  </span>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">
                  Confirm Password
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="password"
                  formControlName="confirmPassword"
                  class="form-control fs-6"
                  [ngClass]="{
                    'is-invalid':
                      registerForm.controls['confirmPassword'].invalid &&
                      registerForm.controls['confirmPassword'].touched,
                  }"
                  required
                />
                <div
                  *ngIf="
                    registerForm.controls['confirmPassword'].invalid &&
                    registerForm.controls['confirmPassword'].touched
                  "
                  class="invalid-feedback"
                >
                  Please confirm your password.
                </div>
                <div *ngIf="passwordMismatch" class="text-danger">
                  Passwords do not match.
                </div>
              </div>
              <div class="col-12">
                <re-captcha
                  (resolved)="getCaptchaValue($event)"
                  siteKey="{{ captchaKey }}"
                ></re-captcha>
                <p class="text-danger" *ngIf="!captchaIsValid">
                  Please validate you are not a robot before submitting.
                </p>
              </div>
              <div class="col-12">
                <button type="submit" class="btn btn-primary mt-2">
                  Register
                </button>
              </div>
              <div class="col-12">
                <p class="small mt-2">
                  If you need assistance, please contact us at 1.800.444.3584.
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</main>
